// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"272c9642","455":"10532131","546":"3d18384d","697":"2caa35dc"}[chunkId] + ".chunk.js";
};